import React from "react";
import clsx from "clsx";

interface SpinnerProps {
  variant?: 'primary' | 'secoundary' | 'danger' | 'success',
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ variant, className }) => (
  <div className={clsx("spinner-border", variant && `text-${variant}`, className)}>
    <span className="visually-hidden">Loading...</span>
  </div>
);

export default Spinner;